import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleBreakEvenReportData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleBreakEvenReportDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleBreakEvenReportDataStore",
			variables: true,
		})
	}
}

export async function load_VehicleBreakEvenReportData(params) {
  await initClient()

	const store = new VehicleBreakEvenReportDataStore()

	await store.fetch(params)

	return {
		VehicleBreakEvenReportData: store,
	}
}
